import pathify from 'vuex-pathify'
export default pathify

// pathify.options.mapping = 'standard'
pathify.options.deep = 2